module.exports = __webpack_public_path__ + "static/media/StrengthsIdentification.f2bf7a0c.mp3";